import { Action, createReducer, on } from '@ngrx/store';
import {
  createAdminOffMarketProperty,
  createAdminOffMarketPropertyFailure,
  createAdminOffMarketPropertySuccess,
  getAdminOffMarketProperties,
  getAdminOffMarketPropertiesFailure,
  getAdminOffMarketPropertiesSuccess,
  getAdminOffMarketPropertyDetails,
  getAdminOffMarketPropertyDetailsFailure,
  getAdminOffMarketPropertyDetailsSuccess,
} from './off-market-properties.action';
import { OffMarketProperty } from './off-market-properties.model';

export interface OffMarketPropertiesState {
  list: OffMarketProperty[];
  detail: OffMarketProperty | null;
  loading: boolean;
  error: any;
  pageNumber: number | null;
  pageSize: number | null;
  totalPages: number | null;
  totalRecords: number | null;
}

export const initialState: OffMarketPropertiesState = {
  list: [],
  detail: null,
  loading: false,
  error: null,
  pageNumber: null,
  pageSize: null,
  totalPages: null,
  totalRecords: null,
};

export const OffMarketPropertiesReducer = createReducer(
  initialState,
  // Add your case reducers here
  on(
    createAdminOffMarketProperty,
    getAdminOffMarketProperties,
    getAdminOffMarketPropertyDetails,
    (state) => ({
      ...state,
      loading: true,
    })
  ),

  on(createAdminOffMarketPropertySuccess, (state, { data }) => ({
    ...state,
    loading: false,
  })),

  on(
    createAdminOffMarketPropertyFailure,
    getAdminOffMarketPropertyDetailsFailure,
    (state, { error }) => ({
      ...state,
      loading: false,
      error: error,
    })
  ),

  on(getAdminOffMarketPropertiesSuccess, (state, { data }) => ({
    ...state,
    list: data.result as OffMarketProperty[],
    pageNumber: data.pageNumber,
    pageSize: data.pageSize,
    totalPages: data.totalPages,
    totalRecords: data.totalRecords,
    loading: false,
  })),

  on(getAdminOffMarketPropertiesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error,
  })),

  on(getAdminOffMarketPropertyDetailsSuccess, (state, { data }) => ({
    ...state,
    detail: data,
    loading: false,
  }))
);

// Selector
export function reducer(
  state: OffMarketPropertiesState | undefined,
  action: Action
) {
  return OffMarketPropertiesReducer(state, action);
}
